import type React from "react"
import styled from "styled-components"
import { Icon, type IconProps } from "~/components/Icon"
import type { FontAwesomeIcon } from "~/ur-react-components"

interface BaseButtonProps {
  width?: string
}

const BaseButton = styled.button<BaseButtonProps>`
  width: ${(props) => props.width ?? "auto"};
  // The design uses inner borders, so we have to adjust the padding accordingly
  padding: 18px 28px;
  background: ${(props) => props.theme.colors.primary40};
  /* Elevation 2 */

  box-shadow: -4px 4px 16px rgba(62, 34, 117, 0.35);
  border-radius: 8px;

  outline: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // Gap between icon and text6
  gap: 10px;

  outline: none;
  border: 4px solid transparent;

  color: white;
  font-weight: 600;

  cursor: pointer;

  box-sizing: border-box;

  &:hover,
  &:focus {
    background: ${(props) => props.theme.colors.primary50};
    border: 4px solid ${(props) => props.theme.colors.primary50};
  }

  &:active {
    background: ${(props) => props.theme.colors.primary50};
    border: 4px solid ${(props) => props.theme.colors.primary30};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

const InnerText = styled.span``

export interface LargeButtonProps {
  width?: string
  leftIcon?: FontAwesomeIcon
  rightIcon?: FontAwesomeIcon

  leftIconProps?: IconProps
  rightIconProps?: IconProps

  onClick?: () => void
}

export const LargeButton: React.CFC<LargeButtonProps> = ({
  width,
  children,
  leftIcon,
  rightIcon,
  leftIconProps,
  rightIconProps,
  onClick,
}) => {
  return (
    <BaseButton width={width} onClick={onClick}>
      {leftIcon && <Icon icon={leftIcon} {...leftIconProps} />}
      <InnerText>{children}</InnerText>
      {rightIcon && <Icon icon={rightIcon} {...rightIconProps} />}
    </BaseButton>
  )
}
